import React, { useContext, useEffect, useState, useRef } from "react";
import { Box, Button, Checkbox, CircularProgress, Dialog, DialogContent, FormControl, FormControlLabel, FormGroup, IconButton, InputLabel, MenuItem, Select, TextField, Typography, Fab, DialogActions, Tabs, Tab, Autocomplete, Divider, Chip } from "@mui/material";
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import DeleteIcon from '@mui/icons-material/Delete';
import Tooltip from "@mui/material/Tooltip";
import { Check as CheckIcon, Clear as ClearIcon, Close, CropSharp, Details } from "@mui/icons-material";
import { CloseOutlined } from "@mui/icons-material";
import { Stack } from "@mui/material";
// import { CircularProgress } from "@mui/material"; // Added import for CircularProgress
import styled from "styled-components";
import { ACTIVITY_STATUS, ROLES } from "../../constants";
import moment from "moment";
import OpaqueLoading from "../opaqueLoading/opaqueLoading";
import { DataGrid, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarDensitySelector, GridToolbarExport, GridToolbarFilterButton } from "@mui/x-data-grid";
import { AuthContext } from "../contextAPI/ContextAPI";
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import MakeVisitRouteModal from "./MakeVisitRouteModal";
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from "dayjs";
import { get, param } from "jquery";
const isMobile = window.innerWidth < 900;
const TotalAmountTypography = styled(Typography)`
  position: absolute;
  bottom: 10px;
  right: 10px;
  font-size: ${isMobile ? "14px" : "inherit"};
  bottom: ${isMobile ? "85px" : "70px"};
  right: ${isMobile ? "15px" : "70px"};
`;
const ModalHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  padding: 10px;
`;
const TableContainer = styled.div`
  // height: calc(
  //   100vh - ${isMobile ? "106px - 20px - 82.23px" : "100px - 20px - 23.77px"}
  // );
  width: ${isMobile ? "100%" : "98%"};
  // border: solid 1px lightGrey;
  border-radius: 8px;
  margin-left:${isMobile ? "0px" : "10px"};
  margin-bottom:${isMobile ? "0px" : "10px"};
`;
const InputFieldContainer = styled.div`
  margin: 20px 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  label {
    margin-bottom: 0px;
  }`;
const TabsContainer = styled.div`
  ${isMobile && `
    height: calc(100vh - 176px - 20px - 43.77px);
  `}`
const StyledTabs = styled(Tabs)`
  border-bottom: solid 1px lightGrey;
`;
const ModalActionsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
  margin-bottom: 20px;
`;

const AddRoutePlan = ({ props, onClose, remarks, dataProp, id, distributorId, fetchData, status, editModalData, editMode, partyList }) => {
  const [tabValue, setTabValue] = useState(0);
  const [loading, setLoading] = useState(false)
  const [form, setForm] = useState({
  })
  const [errors, setErrors] = useState({});
  const [party, setParty] = useState([])
  const [newParty, setNewParty] = useState([])
  const [newParty1, setNewParty1] = useState([])
  const [selectParty, setSelectParty] = useState(null)
  const [party1, setParty1] = useState(null)
  const [selectParty1, setSelectParty1] = useState(null)
  const [rsms, setRsms] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [asms, setAsms] = useState([]);
  const [rms, setRms] = useState([]);
  const [rm, setRm] = useState("")
  const [rsm, setRsm] = useState("")
  const [visitRouteModal, setVisitRouteModal] = useState(false);
  const [asm, setAsm] = useState("")
  const [userData, setUserData] = useState(JSON.parse(localStorage.getItem('storedUserData')).user)
  const [date, setDate] = useState()
  const [dataGrid, setDataGrid] = useState([])
  const [visitType, setVisitType] = useState([])
  const [schoolSearch, setSchoolSearch] = useState("");
  const [schoolOptions, setSchoolOptions] = useState([]);
  const [schoolLoading, setSchoolLoading] = useState(false);
  const [schoolDropdownOpen, setSchoolDropdownOpen] = useState(false);
  const debounceTimeout = useRef(null);
  const today = dayjs();
  const tomorrow = today.add(0, 'day');
  const dayAfterTomorrow = today.add(7, 'day');
  const [distributorSearch, setDistributorSearch] = useState("");
  const [distributorOptions, setDistributorOptions] = useState([]);
  const [distributorLoading, setDistributorLoading] = useState(false);
  const [distributorDropdownOpen, setDistributorDropdownOpen] = useState(false);
  const distributorDebounceTimeout = useRef(null);
  const [categories, setCategories] = useState([]);
  const [board, setBoard] = useState("");
  const [category, setCategory] = useState("");
  const [boards, setBoards] = useState([]);

  const debouncedDistributorSearch = (searchValue) => {
    if (distributorDebounceTimeout.current) clearTimeout(distributorDebounceTimeout.current);
    distributorDebounceTimeout.current = setTimeout(async () => {
      setDistributorLoading(true);
      try {
        const payload = { ownerId: rm, filter: searchValue };
        const results = await window.Platform.database.getAllDistri(payload);
        // Exclude already selected distributors
        const selectedDistributorIds = dataGrid.map(item => item.leadId);
        const filteredDistributors = results.data.filter(
          distributor => !selectedDistributorIds.includes(distributor.distributorID)
        );
        setDistributorOptions(filteredDistributors);
      } catch (err) {
        setDistributorOptions([]);
      }
      setDistributorLoading(false);
    }, 400);
  };
  const handleChangeTab = (event, newValue) => {
    setTabValue(newValue);
  };
  const formatDate = (data) => {
    const timestamp = new Date(data.$d);
    const datePickerResponse = new Date(data.$d);
    const year = datePickerResponse.getFullYear();
    const month = String(datePickerResponse.getMonth() + 1).padStart(2, '0');
    const day = String(datePickerResponse.getDate()).padStart(2, '0');
    const formattedDate = `${year}-${month}-${day}`;
    const unixTimestamp = Math.floor(timestamp.getTime() / 1000);
    setDate(data)

    changeHandler("date", unixTimestamp)
  }

  useEffect(() => {
    getSchoolCategory();
    getBoard();
    if (userData?.role.toLowerCase().includes('admin')) {
      getAllUsers()
    }
    if (userData?.role == 'rsm') {
      getUsers('rsm', userData?.id)
    }
    if (userData?.role == 'asm') {
      getUsers('asm', userData?.id)
    }
  }, [])

  async function getAllUsers() {
    let results = await window.Platform.database.fetchEmployees()
    setAllUsers(results?.data)
    setRsms(results?.data?.filter((ele) => ele.role.toLowerCase() == 'rsm'))
    setRms(results?.data?.filter((ele) => ele.role.toLowerCase() == 'se'))
    setAsms(results?.data?.filter((ele) => ele.role.toLowerCase() == 'asm'))
  }

  // useEffect(() => {
  //   if (form?.partyName == "school") {
  //     setSelectParty(null)
  //     debouncedSchoolSearch()
  //   }
  //   else if (form?.partyName == "distributor") {
  //     setSelectParty(null)
  //     getDistributor({ ownerId: rm })
  //   }
  //   // getPartyLead({ ownerId: form.ownerId })
  //   getRouteVisitType()

  // }, [form?.partyName, rm, dataGrid, board, category])

  useEffect(() => {
    if (form?.partyName === "school") {
      setSelectParty(null);
      setSchoolSearch("");
      debouncedSchoolSearch("");     // load full list
    }
    else if (form?.partyName === "distributor") {
      setSelectParty(null);
      getDistributor({ ownerId: rm });
    }

    getRouteVisitType();
  }, [form?.partyName, rm, board, category]);


  const changeHandler = (fieldName, value) => {
    setForm((prevForm) => ({ ...prevForm, [fieldName]: value }));
  };

  const debouncedSchoolSearch = (value) => {
    if (debounceTimeout.current) clearTimeout(debounceTimeout.current);
    if (value.length > 10) return; // Limit search to 10 characters

    debounceTimeout.current = setTimeout(async () => {
      setSchoolLoading(true);
      try {
        const payload = { ownerId: rm, filter: value, board, category };
        const res = await window.Platform.database.getAllSchool(payload);

        const selectedIds = dataGrid.map(x => x.leadId);
        const filtered = res.data.filter(s => !selectedIds.includes(s.schoolId));

        setSchoolOptions(filtered);
      } catch (e) {
        setSchoolOptions([]);
        window.NotificationUtils.showError("No Data Found");
      }

      finally {
        setSchoolLoading(false);
      }
    }, 400);
  };

  useEffect(() => {
    if (editMode && partyList?.length) {
      // console.log(partyList,"partyListtttttttttttttttttt")
      const formattedPartyList = partyList.map((item, index) => {
        const isSchool = item.partyType === 1;

        return {
          id: index,
          partyType: item.partyType,
          leadId: item.partyId,
          visit_type_name: item.visit_type_name,
          visitType: item.visitType,
          index: item.partyInd,
          name: isSchool
            ? item.schoolName : item?.DistributorName
        };
      });

      setDate(dayjs(editModalData?.date));
      setDataGrid(formattedPartyList);


      const dateObj = new Date(editModalData?.date); // Parse the ISO string
      const year = dateObj.getFullYear();
      const month = String(dateObj.getMonth() + 1).padStart(2, '0');
      const day = String(dateObj.getDate()).padStart(2, '0');

      const formattedDate = `${year}-${month}-${day}`; // If needed for display

      let unixTimestamp = Math.floor(dateObj.getTime() / 1000);
      setForm({
        date: unixTimestamp,
        visitType: editModalData?.routeVisitId,
        partyName: editModalData?.party_type === "1" ? "school" : editModalData?.party_type === "0" ? "distributor" : "",
      });

      setRsm(rsm || "");
      setAsm(asm || "");
      setRm(editModalData?.ownerId || "");
    }

  }, [editMode, partyList, editModalData]);

  const getDistributor = async (details) => {
    try {
      setLoading(true)
      // if(editMode){
      let results = await window.Platform.database.getAllDistri(details);
      const selectedDistributorIds = dataGrid.map(item => item.leadId);
      const filteredDistributors = results.data.filter(
        Distributor => !selectedDistributorIds.includes(Distributor.distributorID)
      );
      setParty(filteredDistributors);
      setLoading(false);
      // }
      // else{
      //   let results = await window.Platform.database.getAllDistri(details);
      //   setParty(results.data)
      //   setLoading(false)
      // }
    }
    catch (err) {
      console.log(err);
      setLoading(false)
    }
  }

  const handleSave = async () => {
    setLoading(true);
    try {
      const errors = validateForm(form);
      setErrors(errors);
      if (Object.keys(errors)?.length === 0) {
        let newPartyRohit
        // setLoading(true);
        const arrayOfPartyList = dataGrid?.map(item => {
          // console.log(item,"dewreewrwerwerewrewrewrwerwer")
          newPartyRohit = item.partyType
          return {
            partyId: item.leadId,
            // partyType: form?.partyName == "school" ? "1" : "0",
            partyType: item.partyType,
            // partyInd: item.index,
            visitType: item.visitType
          }
        });


        if (editMode) {
          const finalData = { date: form.date, ownerId: rm, party_type: newPartyRohit, partyList: arrayOfPartyList, routeId: editModalData?.routeId }
          // console.log(finalData,"payload of updateRoutePlan")
          // return;
          const results = await window.Platform.database.updateRoutePlan(finalData);

          if (results.status) {
            window.NotificationUtils.showError(results.message);
            setLoading(false);
            return;
          }
          window.NotificationUtils.showSuccess("Route Plan Updated Successfully!")
        }
        else {
          const finalData = { date: form.date, ownerId: rm, party_type: newPartyRohit, partyList: arrayOfPartyList }
          // console.log(finalData,"payLoad of addRoutePlan")
          // return;
          const results = await window.Platform.database.addRoutePlan(finalData);

          if (results.status) {
            window.NotificationUtils.showError(results.message);
            setLoading(false);
            return;
          }
          window.NotificationUtils.showSuccess("Route Plan Added Successfully!")
        }
        setLoading(false)
        onClose()
        fetchData()
      } else {
        setLoading(false)
        window.NotificationUtils.showError("Please fill all required fields.")
      }
    }
    catch (error) {
      console.log(error)
      setLoading(false)
    }
  };

  const getPartyLead = async (details) => {
    try {
      setLoading(true)
      let results = await window.Platform.database.getPartyLead(details);
      setParty1(results.data)
      setLoading(false)
    }
    catch (err) {
      console.log(err);
      setLoading(false)
    }
  }

  const getRouteVisitType = async (details) => {
    try {
      setLoading(true)
      let results = await window.Platform.database.getRouteVisitType(details);
      setVisitType(results.data)
      setLoading(false)
    }
    catch (err) {
      console.log(err);
      setLoading(false)
    }
  }

  async function getUsers(role, id) {
    if (id != "") {
      let results = await window.Platform.database.getUsersBasedOnManager({ userId: id })
      if (role == 'rsm') {
        setAsms(results?.data)
        setRms(results?.data1)
      }
      if (role == 'asm') {
        setRms(results?.data)
      }
    } else {
      if (role == 'rsm') {
        setRm("")
        setAsm("")
        setRms(allUsers?.filter((ele) => ele.role == 'se'))
        setAsms(allUsers?.filter((ele) => ele.role == 'asm'))
      }
      if (role == 'asm') {
        setRm("")
        setRms(allUsers?.filter((ele) => ele.role == 'se'))
      }
    }
  }

  async function getSchoolCategory() {
    try {
      setLoading(true);
      let results = await window.Platform.database.getSchoolCategory();
      if (results?.status) {
        window.NotificationUtils.showError(results.message);
        setLoading(false);
      }
      else {
        setCategories(results?.data)
        setLoading(false);
      }
    } catch (error) {
      console.error("ERRORCHECK", error);
      window.NotificationUtils.showError("Error Fetching Data");
      // setLoading(false);
    }
    finally {
      setLoading(false)
    }
  }

  const getBoard = async () => {
    let results = await window.Platform.database.getBoard();
    if (results?.hasError) {
      window.NotificationUtils.showError(results.message);
      setLoading(false);
    }
    else {
      setBoards(results.data);
      setLoading(false);
    }
  }
  const renderContent1 = () => {
    return (
      <div style={{ overflowY: "auto" }}>
        <div className="row container">
          {userData?.role.includes('admin') && <div className="col-md-4 col-sm-12">
            <Typography variant="body1" sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>Select HO:</Typography>
            <Select
              value={rsm}
              variant="outlined"
              size="small"
              onChange={(e) => { setRsm(e.target.value); getUsers('rsm', e.target.value) }}
              sx={{ color: "black", fontSize: "14px", fontWeight: "500", width: 300, }}
            // sx={{ width: 300, fontSize: 14 }}
            >
              <MenuItem value="" sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>All</MenuItem>
              {rsms.map((role) => (
                <MenuItem key={role} value={role.id} sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>{role.name} - {role.username}</MenuItem>
              ))}
            </Select>
          </div>}
          {userData?.role != 'asm' && <div className="col-md-4 col-sm-12">
            <Typography variant="body1" sx={{ color: "black", fontSize: "14px", fontWeight: "500" }} >Select ARM:</Typography>
            <Select
              value={asm}
              variant="outlined"
              size="small"
              onChange={(e) => { setAsm(e.target.value); getUsers('asm', e.target.value) }}
              sx={{ width: 300, fontSize: 14 }}
            >
              <MenuItem value="" sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>All</MenuItem>
              {asms.map((role) => (
                <MenuItem key={role} value={role.id} sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>{role.name} - {role.username}</MenuItem>
              ))}
            </Select>
          </div>}
          <div className="col-md-4 col-sm-12" >
            <Typography variant="body1" sx={{ color: "black", fontSize: "14px", fontWeight: "500" }} >Select Relationship Manager:</Typography>
            <Select
              value={rm}
              variant="outlined"
              size="small"
              sx={{ color: "black", fontSize: "14px", fontWeight: "500", width: 300, }}
              onChange={(e) => { setRm(e.target.value) }}
              // sx={{ width: 300, fontSize: 14 }}
              disabled={dataGrid?.length > 0}
            >
              <MenuItem value="" sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>All</MenuItem>
              {rms.map((role) => (
                <MenuItem key={role} value={role.id} sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>{role.name} - {role.username}</MenuItem>
              ))}
            </Select>
          </div>
        </div>
        <Stack direction={"row"} spacing={2} padding={2}>
          <FormControl style={{ width: isMobile ? "100%" : "100%" }}>
            <InputLabel id="select-label" sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>Route Visit Type</InputLabel>
            <Select
              labelId="select-label"
              id="select"
              sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}
              value={form.visitType || ""}
              onChange={(e) => changeHandler("visitType", e.target.value)}
              label="Route Visit Type"
            >
              {visitType?.map((option, optionIndex) => (
                <MenuItem key={option.routeVisitTypeID} value={option.routeVisitTypeID} sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>
                  {option.routeVisitType}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <LocalizationProvider dateAdapter={AdapterDayjs} sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>
            <DatePicker label="Route Date" minDate={tomorrow} sx={{ color: "black", fontSize: "14px", fontWeight: "500", width: "100%" }}
              maxDate={dayAfterTomorrow} value={date} disabled={loading || dataGrid?.length > 0} format="YYYY/MM/DD" onChange={(data) => formatDate(data)} />
          </LocalizationProvider>

        </Stack>
        <Stack direction={"row"} spacing={2} padding={2} >
          <Stack direction={"row"} spacing={2} sx={{ width: "100%" }}>
            <FormControl style={{ width: isMobile ? "100%" : "100%" }}>
              <InputLabel sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>Select Party</InputLabel>
              <Select
                labelId={`Party`}
                label="Select Party"
                sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}
                value={form?.partyName || ""}
                onChange={(e) => changeHandler('partyName', e.target.value)}
              >
                <MenuItem value="" hidden sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>
                  Select Party
                </MenuItem>
                <MenuItem value="school" sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>
                  School
                </MenuItem>
                <MenuItem value="distributor" sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>
                  Distributor
                </MenuItem>
              </Select>
            </FormControl>
          </Stack>
        </Stack>
        {form?.partyName == "school" && <Stack direction={"row"} spacing={2} padding={2} >
          <FormControl fullWidth>
            <InputLabel sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>Select Board</InputLabel>
            <Select
              value={board}
              label="Select Board"
              sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}
              onChange={(e) => { setBoard(e.target.value) }}
            >
              <MenuItem value="" sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>All</MenuItem>
              {boards.map((ele, ind) => (
                <MenuItem key={ind} value={ele.boardId} sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>{ele.boardName} </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl fullWidth>
            <InputLabel sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>Select Category</InputLabel>
            <Select
              value={category}
              label="Select Category"
              sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}
              onChange={(e) => { setCategory(e.target.value) }}
            >
              <MenuItem value="" sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>All</MenuItem>
              {categories.map((ele, ind) => (
                <MenuItem key={ind} value={ele.id} sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>{ele.name}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Stack>}
        <Stack direction={"row"} spacing={2} padding={2} >
          <Stack direction={"row"} spacing={2} sx={{ width: "100%" }}>
            {form?.partyName === "school" && (
              <Box sx={{ width: "100%", position: "relative" }}>

                <Autocomplete
                  disabled={(loading || !form?.date || !form?.visitType) && (!rm || !asm)}
                  open={schoolDropdownOpen}
                  onOpen={() => setSchoolDropdownOpen(true)}
                  onClose={() => setSchoolDropdownOpen(false)}
                  loading={schoolLoading}
                  options={schoolOptions}
                  value={selectParty}
                  getOptionLabel={(option) =>
                    option?.schoolName ? `${option.schoolId} - ${option.schoolName}` : ""
                  }
                  onChange={(e, value) => {
                    setSelectParty(value);
                    changeHandler("partyId", value?.schoolId);
                  }}
                  onInputChange={(e, value) => {
                    setSchoolSearch(value);
                    debouncedSchoolSearch(value);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Search / Select School"
                      fullWidth
                      variant="outlined"
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            {schoolLoading ? <CircularProgress size={20} /> : null}
                            {params.InputProps.endAdornment}
                          </>
                        ),
                      }}
                    />
                  )}
                />
              </Box>
            )}

            {form?.partyName == "distributor" && <Autocomplete
              options={party}
              getOptionLabel={(option) => option.DistributorName && option.distributorID ? `${option.distributorID} - ${option.DistributorName}` : option.DistributorName || option.distributorID || ""}
              getOptionValue={(option) => option?.distributorID || ''}
              style={{ width: "100%" }}
              value={selectParty}
              disabled={loading
                || !rm || !date || !form?.visitType
              }
              noOptionsText={loading ? "Loading..." : "No option"}
              onChange={(event, value) => {
                changeHandler("partyId", value?.distributorID)
                setSelectParty(value)
              }}
              onInputChange={(e, value) => {
                const matchingOption = party.find((option) => option.DistributorName === value.DistributorName);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={"Select Distributor"}
                  required
                  variant="outlined"
                  error={errors.distributor ? true : false}
                />
              )} />}
            <Button variant="text" disabled={!selectParty} onClick={() => additem()}>Add</Button>
          </Stack>
        </Stack>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <DataGrid
            className="payrollGrid"
            style={{ height: !dataGrid?.length ? '200px' : 'auto', maxWidth: "97%" }}
            density="compact"
            rows={dataGrid || []}
            columns={getColumns()}
            rowHeight={60}
            disableSelectionOnClick
            disableRowSelectionOnClick
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 10,
                },
              },
            }}
            pageSizeOptions={[10]}
          />

        </div>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', margin: "20px", marginTop: "35px" }}>
          <Button variant="contained" onClick={() => handleSave()}>
            {editMode ? "Update route Plan" : "Create route Plan"}
          </Button>
        </div>
      </div>
    )
  }

  const additem = () => {
    const length = dataGrid?.length + 1;
    const visitTypeObj = visitType.find(
      (vt) => vt.routeVisitTypeID === form?.visitType
    );
    const visit_type_name = visitTypeObj ? visitTypeObj.routeVisitType : "";

    let pushedItem;

    if (form?.partyName === "school") {
      pushedItem = {
        name: selectParty?.schoolName,
        leadId: selectParty?.schoolId,
        type: "School",
        id: length,
        partyType: "1",
        visitType: form?.visitType,
        visit_type_name
      };
      const newp = party.filter((p) => p.schoolId !== selectParty?.schoolId);
      setParty(newp);
    } else if (form?.partyName === "distributor") {
      pushedItem = {
        name: selectParty?.DistributorName,
        leadId: selectParty?.distributorID,
        type: "Distributor",
        id: length,
        partyType: "0",
        visitType: form?.visitType,
        visit_type_name
      };
      const newp = party.filter((p) => p.distributorID !== selectParty?.distributorID);
      setParty(newp);
    }
    setNewParty(prev => [...prev, selectParty]);
    setSelectParty(null);
    setDataGrid(prev => [...prev, pushedItem]);
  };

  const validateForm = (data) => {
    const errors = {};
    if (!dataGrid?.length) {
      if (data.ownerId?.trim()) {
        if (!data.school?.trim()) {
          errors.school = "School name is required";
        }
      }
    }
    return errors;
  };

  const getColumns = () => {
    let result = [
      {
        field: "leadName",
        headerName: "Party Name",
        sortable: false,
        width: 350,
        renderCell: (params) => {
          return (
            <Tooltip title={params.row?.name || "N/A"}>
              <Typography variant="inherit">{params.row?.name || "N/A"}</Typography>
            </Tooltip>
          )
        },
      },
      {
        field: "type",
        headerName: "Party Type",
        sortable: false,
        width: 150,
        renderCell: (params) => {
          return (
            <Tooltip title={params?.row?.partyType == 1 ? "School" : params?.row?.partyType == 0 ? "Distributor" : "" || "N/A"}>
              <Typography variant="inherit">{params?.row?.partyType == 1 ? "School" : params?.row?.partyType == 0 ? "Distributor" : "" || "N/A"}</Typography>
            </Tooltip>
          )
        },
      },
      {
        field: "Visit Type",
        headerName: "Visit Type",
        sortable: false,
        width: 150,
        renderCell: (params) => {
          return (
            <Tooltip title={params.row.visit_type_name || "N/A"}>
              <Typography variant="inherit">{params.row.visit_type_name || "N/A"}</Typography>
            </Tooltip>
          )
        },
      },
      {
        field: "Actions",
        headerName: "Actions",
        width: 100,
        sortable: false,
        renderCell: (params) => {
          return (
            <IconButton onClick={() => handleDeleteEmploye(params.row)}>
              <DeleteIcon />
            </IconButton>
          )
        },
      },
    ];
    return result
  }

  const handleDeleteEmploye = (row) => {
    setDataGrid(prev => prev.filter(el => el.id !== row.id));
  };

  return (
    <>
      <Dialog disableEnforceFocus maxWidth="lg" fullWidth={true} open={true} >
        {loading && <OpaqueLoading />}
        <ModalHeaderContainer style={{ marginBottom: 2, paddingBottom: 3 }}>
          <Typography variant={isMobile ? "h6" : "h5"}>
            {editMode ? "Edit Route-Plan" : "Add Route-Plan"}
            <Tooltip title="Order Id"> {id} </Tooltip>
          </Typography>
          <IconButton onClick={onClose} ><CloseOutlined /></IconButton>
        </ModalHeaderContainer>
        <TableContainer>
          <TabsContainer>
            <StyledTabs variant="fullWidth" value={tabValue} onChange={handleChangeTab} indicatorColor="primary" textColor="primary">
              <Tab label="Route Details" />
            </StyledTabs>
            {tabValue == 0 && renderContent1()}
          </TabsContainer>
        </TableContainer>
      </Dialog>
    </>
  );
};

export default AddRoutePlan;